<template>
  <v-card elevation="0" min-height="100%">
    <v-card-text>
      <v-form ref="form" class="mb-2">
        <FormSectionHostel/>
      </v-form>
      <v-slide-x-transition>
        <h6 v-if="show_dubli && duplicate()" class="red--text text-h6">
          Вы выбрали одинаковые комнаты: {{duplicate()}}
        </h6>
      </v-slide-x-transition>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-if="Object.keys(show_statement_hostel).length === 0"
        block
        outlined
        rounded
        color="teal darken-1"
        @click="createStatement"
      >
        Подать
      </v-btn>
      <v-btn
        v-else
        block
        outlined
        rounded
        color="teal darken-1"
        @click="updateForm"
      >
        Сохранить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
    import FormSectionHostel from "../../Forms/FormSectionHostel";
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
    import StatementHostelPDF from "../../../../../makepdfs/statement_hostel/statement_hostel_pdf";

    export default {
        name: "ChoosePlace",
        data: () => ({
            show_dubli: false
        }),
        components: {
            FormSectionHostel,
        },
        computed: {
            ...mapState({
                show_statement_hostel: state => state.interactionStatement.show_statement_hostel,
                statement_hostel: state => state.interactionStatement.statement_hostel,
            }),
            ...mapGetters({
                setPrivilege: 'mainHostel/setPrivilege'
            }),
        },
        methods: {
            ...mapMutations({
                dialogVisible: 'interactionStatement/dialogVisible',
            }),
            ...mapActions({
                CreateStatement: 'interactionStatement/CreateStatement',
                UpdateStatement: 'interactionStatement/UpdateStatement',
                ShowVerifStatement: 'interactionStatement/ShowVerifStatement',
            }),
            createStatement() {
                if (this.$refs.form.validate()) {
                    if (!this.duplicate()) {
                        this.CreateStatement()
                        this.closeDialog()
                    } else this.show_dubli = true
                }
            },
            duplicate() {
                let list = []
                for (let i = 0; i < this.statement_hostel.array_place_hostel.length; i++) {
                    let place = this.statement_hostel.array_place_hostel[i].name_hostel + " " +
                        this.statement_hostel.array_place_hostel[i].name_room
                    if (list.includes(place)) {
                        return place
                    }
                    list.push(place)
                }
            },
            updateForm() {
                if (this.$refs.form.validate()) {
                    this.UpdateStatement()
                    this.closeDialog()
                }
            },
            closeDialog(){
                this.$emit('closeDialog')
            }
            // createStatementPDF(){
            //     StatementHostelPDF.createPDF(this.getYear, this.user.facility, this.user.group, this.show_statement_hostel.id, this.setDate, this.show_statement_hostel.place_hostel, this.fullName )
            // },
        },
    }
</script>

<style scoped>

</style>